<template>
  <div class="general-wrapper">
    <Header parent="stickers_gallery">
      <template #title>
        {{ $t("tables.orders_history") }}
      </template>
    </Header>

    <IQOSTable
      :rows="shipments"
      :cols="[
        {
          title: $t('subscription.transactions.date'),
          key: 'created_at',
          date: true,
        },
        {
          title: $t('subscription.transactions.time'),
          key: 'created_at',
          time: true,
        },
        {
          title: $t('shipments_table.recipient'),
          key: 'recipient',
        },
        {
          title: $t('shipments_table.delivery'),
          key: 'delivery',
          renderer: (r) => r.warehouse || r.address,
        },
        {
          title: $t('shipments_table.contents'),
          key: 'contents',
        },
        {
          title: $t('subscription.transactions.sum'),
          key: 'total',
          unit: 'UAH',
        },
        {
          title: $t('subscription.transactions.status'),
          key: 'status',
        },
      ]"
    >
      <template #col-contents="slotProps">
        <div
          v-for="(content, index) in slotProps.rowItem.contents"
          :key="index"
        >
          {{ capitalize(content.template) }} ({{
            content.system.toUpperCase()
          }}) x{{ content.count }}
        </div>
      </template>

      <template #col-status="slotProps">
        <span class="green-5-color" v-if="slotProps.rowItem.status == 'shipped'">
          {{ $t("shipments_table.statuses.shipped") }}
        </span>
        <span class="red-4-color" v-if="slotProps.rowItem.status == 'returned'">
          {{ $t("shipments_table.statuses.returned") }}
        </span>
        <span class="v1-grey-10-color" v-if="slotProps.rowItem.status == 'shipping'">
          {{ $t("shipments_table.statuses.shipping") }}
        </span>
        <span
          class="orange-4-color"
          v-if="
            slotProps.rowItem.status == 'preparing' ||
            slotProps.rowItem.status == 'printing'
          "
        >
          {{ $t("shipments_table.statuses.preparing") }}
        </span>
      </template>
    </IQOSTable>
  </div>
</template>


<script>
import IQOS from "@/components/IQOS.vue";

import ShipmentAPI from "@/api/shipment";

import ModeIcon from "@/components/ModeIcon.vue";

export default {
  data() {
    return {
      shipments: [],
    };
  },
  methods: {
    capitalize(str) {
      return str.substring(0, 1).toUpperCase() + str.substring(1);
    },
  },
  components: {
    IQOS,
  },
  mounted() {
    ShipmentAPI.getArchive(this.$store.state.cafe._id)
      .then((data) => {
        this.shipments = data.shipments;
      })
      .catch((error) => {
        this.$store.dispatch("showError", "shipment_failed");
      });
  },
};
</script>

<style scoped>
tbody {
  display: table-row-group;
}
</style>
